export class EdeliveryLabels {

    // Preferences Field Labels
    static ACCOUNT: string = 'EDELIVERY.GRID.ACCOUNT';
    static EDELIVERY_DOCUMENTS: string = 'EDELIVERY.GRID.DOCUMENTS';
    static EDELIVERY_PREFERENCES_TITLE: string = 'EDELIVERY.PREFERENCES.EDELIVERY_PREFERENCES_TITLE';
    static EDIT_LABEL: string = 'EDELIVERY.PREFERENCES.EDIT_LABEL';
    static DELETE_LABEL: string = 'EDELIVERY.EMAIL.DELETE_LABEL';
    static EMAIL_ADDRESS_INFO: string = 'EDELIVERY.DISCLAIMERS.EMAIL_ADDRESS_INFO';
    static INCLUDED: string = 'EDELIVERY.GRID.INCLUDED';
    static INCLUDED_TITLE: string = 'EDELIVERY.GRID.INCLUDED_TITLE';
    static SEE_ALL: string = 'EDELIVERY.GRID.SEE_ALL';
    static SEE_ALL_TITLE: string = 'EDELIVERY.GRID.SEE_ALL_TITLE';
    static COMMUNICATION_TYPES: string = 'EDELIVERY.DISCLAIMERS.COMMUNICATION_TYPES';
    static NO_DOCUMENTS_SETUP: string = 'EDELIVERY.GRID.NO_DOCUMENTS_SETUP';
    static PROXY_INFO: string = 'EDELIVERY.DISCLAIMERS.PROXY_INFO';
    static QPR_DISCLAIMER: string = 'EDELIVERY.DISCLAIMERS.QPR_DISCLAIMER';
    static QPR_DISCLAIMER_EMS: string = 'EDELIVERY.DISCLAIMERS.QPR_DISCLAIMER_EMS';
    static QUICK_ENROLL_LABEL: string = 'EDELIVERY.PREFERENCES.QUICK_ENROLL_LABEL';
    static REMINDER: string = 'EDELIVERY.DISCLAIMERS.REMINDER';
    static EMS_REMINDER: string = 'EDELIVERY.DISCLAIMERS.EMS_REMINDER';
    static REMINDER_LABEL: string = 'EDELIVERY.DISCLAIMERS.REMINDER_LABEL';
    static SAVE_FIRST: string = 'EDELIVERY.DISCLAIMERS.SAVE_FIRST';
    static SAVE_SECOND: string = 'EDELIVERY.DISCLAIMERS.SAVE_SECOND';
    static ELECTRONIC_AGREEMENT: string = 'EDELIVERY.DISCLAIMERS.ELECTRONIC_AGREEMENT';
    static SAVE_THIRD: string = 'EDELIVERY.DISCLAIMERS.SAVE_THIRD';
    static EMAIL_INFO_TOOLTIP: string = 'EDELIVERY.PREFERENCES.EMAIL_INFO_TOOLTIP';
    static RETURN_TO_EMS: string = 'EDELIVERY.PREFERENCES.RETURN_TO_EMS';

    // QUICK_ENROLL
    static HEADER_DESCRIPTION: string = 'EDELIVERY.QUICK_ENROLL.HEADER_DESCRIPTION';
    static HEADER_DESCRIPTION_PART2: string = 'EDELIVERY.QUICK_ENROLL.HEADER_DESCRIPTION_PART2';
    static HEADER_DESCRIPTION_PART3: string = 'EDELIVERY.QUICK_ENROLL.HEADER_DESCRIPTION_PART3';
    static SELECT_ALL: string = 'EDELIVERY.QUICK_ENROLL.SELECT_ALL';
    static SELECT_EMAIL_DESC: string = 'EDELIVERY.QUICK_ENROLL.SELECT_EMAIL_DESC';

    // ONE_CLICK_ENROLL
    static ONE_CLICK_ENROLL_HEADER_DESCRIPTION1: string = 'EDELIVERY.ONE_CLICK_ENROLL.HEADER_DESCRIPTION1';
    static ONE_CLICK_ENROLL_HEADER_DESCRIPTION2: string = 'EDELIVERY.ONE_CLICK_ENROLL.HEADER_DESCRIPTION2';
    static ONE_CLICK_ENROLL_HEADER_DESCRIPTION3: string = 'EDELIVERY.ONE_CLICK_ENROLL.HEADER_DESCRIPTION3';
    static ONE_CLICK_ENROLL_EMAIL_ADDRESS1: string = 'EDELIVERY.ONE_CLICK_ENROLL.EMAIL_ADDRESS1';
    static ONE_CLICK_ENROLL_EMAIL_ADDRESS2: string = 'EDELIVERY.ONE_CLICK_ENROLL.EMAIL_ADDRESS2';
    static ONE_CLICK_ENROLL_EMAIL_PLACEHOLDER: string = 'EDELIVERY.ONE_CLICK_ENROLL.EMAIL_PLACEHOLDER';
    static ONE_CLICK_ENROLL_FOOTER_DESCRIPTION1: string = 'EDELIVERY.ONE_CLICK_ENROLL.FOOTER_DESCRIPTION1';
    static ONE_CLICK_ENROLL_FOOTER_DESCRIPTION2: string = 'EDELIVERY.ONE_CLICK_ENROLL.FOOTER_DESCRIPTION2';
    static ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_1: string = 'EDELIVERY.ONE_CLICK_ENROLL.CANCEL_HEADER_DESCRIPTION_1';
    static ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_2: string = 'EDELIVERY.ONE_CLICK_ENROLL.CANCEL_HEADER_DESCRIPTION_2';
    static ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_3: string = 'EDELIVERY.ONE_CLICK_ENROLL.CANCEL_HEADER_DESCRIPTION_3';
    static ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_4: string = 'EDELIVERY.ONE_CLICK_ENROLL.CANCEL_HEADER_DESCRIPTION_4';

    // Document names
    static STATEMENTS: string = 'EDELIVERY.DOCUMENT_NAMES.STATEMENTS';
    static TRADE: string = 'EDELIVERY.DOCUMENT_NAMES.TRADE';
    static QPR: string = 'EDELIVERY.DOCUMENT_NAMES.QPR';
    static NOTIFICATIONS: string = 'EDELIVERY.DOCUMENT_NAMES.NOTIFICATIONS';
    static TAX: string = 'EDELIVERY.DOCUMENT_NAMES.TAX';
    static PROSPECTUS: string = 'EDELIVERY.DOCUMENT_NAMES.PROSPECTUS';
    static PROXY: string = 'EDELIVERY.DOCUMENT_NAMES.PROXY';
    static APPLICABLE_ACCOUNTS: string = 'EDELIVERY.DOCUMENT_NAMES.APPLICABLE_ACCOUNTS';

    // Emails text
    static EMAIL_TITLE: string = 'EDELIVERY.EMAIL.EMAIL_TITLE';
    static ADD_EMAIL_ADDRESS: string = 'EDELIVERY.EMAIL.ADD_EMAIL_ADDRESS';
    static DELETE_EMAIL_ADDRESS: string = 'EDELIVERY.EMAIL.DELETE_EMAIL_ADDRESS';
    static DELETE_EMAIL_MESSAGE: string = 'EDELIVERY.EMAIL.DELETE_EMAIL_MESSAGE';
    static EDIT_EMAIL_ADDRESS: string = 'EDELIVERY.EMAIL.EDIT_EMAIL_ADDRESS';
    static NO_EMAIL_SETUP_MESSAGE: string = 'EDELIVERY.EMAIL.NO_EMAIL_SETUP_MESSAGE';
    static EMAIL_LABEL: string = 'EDELIVERY.EMAIL.EMAIL_LABEL';
    static CONFIRM_EMAIL_LABEL: string = 'EDELIVERY.EMAIL.CONFIRM_EMAIL_LABEL';
    static INVALID_EMAIL: string = 'EDELIVERY.EMAIL.INVALID_EMAIL';
    static INVALID_EMAIL_MAXLENGTH: string = 'EDELIVERY.EMAIL.INVALID_EMAIL_MAXLENGTH';
    static YES_LABEL: string = 'EDELIVERY.EMAIL.YES_LABEL';
    static NO_LABEL: string = 'EDELIVERY.EMAIL.NO_LABEL';

    // Pending Enrollment Text
    static PENDING_PREFERENCES: string = 'EDELIVERY.DISCLAIMERS.PENDING_PREFERENCES';
    static DOCUMENT_NAME_PENDING: string = 'EDELIVERY.DISCLAIMERS.DOCUMENT_NAME_PENDING';
    static PENDING_EMAIL: string = 'EDELIVERY.DISCLAIMERS.PENDING_EMAIL';
    // static VIEW_PREFERENCES_PENDING: string = 'EDELIVERY.DISCLAIMERS.VIEW_PREFERENCES_PENDING';
    static VIEW_PREFERENCES_PENDING2: string = 'EDELIVERY.DISCLAIMERS.VIEW_PREFERENCES_PENDING2';

    // Agreement text
    static AGREE_LABEL: string = 'EDELIVERY.AGREEMENT.AGREE_LABEL';
    static DISAGREE_LABEL: string = 'EDELIVERY.AGREEMENT.DISAGREE_LABEL';
    static BACK_TO_ENROLLMENT: string = 'EDELIVERY.AGREEMENT.BACK_TO_ENROLLMENT';

    // Confirmation popup
    static CONFIRMATION_POPUP_TITLE: string = 'EDELIVERY.CONFIRMATION_POPUP.CONFIRMATION_POPUP_TITLE';
    static CONFIRMATION_POPUP_TEXT: string = 'EDELIVERY.CONFIRMATION_POPUP.CONFIRMATION_POPUP_TEXT';
    static ENROLLED: string = 'EDELIVERY.CONFIRMATION_POPUP.ENROLLED';
    static DE_ENROLLED: string = 'EDELIVERY.CONFIRMATION_POPUP.DE_ENROLLED';

    // Misc Text
    static SHOW_LESS: string = 'DOCUMENTS_CENTER.TEXT.SHOW_LESS';
    static SHOW_MORE: string = 'DOCUMENTS_CENTER.TEXT.SHOW_MORE';
    static PLEASE_LINK: string = 'DOCUMENTS_CENTER.TEXT.PLEASE_LINK';
    static MORE: string = 'DOCUMENTS_CENTER.TEXT.MORE';
    static CANCEL: string = 'EDELIVERY.MISC.CANCEL';
    static CLOSE: string = 'EDELIVERY.MISC.CLOSE';
    static SAVE: string = 'EDELIVERY.MISC.SAVE';
    static SAVE_NOW: string = 'EDELIVERY.MISC.SAVE_NOW';
    static VIEW_AND_SAVE: string = 'EDELIVERY.MISC.VIEW_AND_SAVE';
    static OK: string = 'EDELIVERY.MISC.OK';
    static ONE_CLICK_ENROLL_BACK: string = 'EDELIVERY.MISC.ONE_CLICK_ENROLL_BACK';
    static ONE_CLICK_ENROLL_OK: string = 'EDELIVERY.MISC.ONE_CLICK_ENROLL_OK';
    static REMIND_ME_LATER: string = 'EDELIVERY.MISC.REMIND_ME_LATER';
    static ACCEPT: string = 'EDELIVERY.MISC.ACCEPT';

    // Errors
    static DATA_NOT_LOADING: string = 'DOCUMENTS_CENTER.ERROR.DATA_NOT_LOADING';
}
